import React from "react";

import "./about.scss";

const About = () => {
  return (
    <div className="about-div">
      <h3 className="about-header">About CRWN STORE</h3>
      <p>
        CRWN is an online shop with all things related to clothing. We have
        shoes, bags, dresses, shirts and anything you can wear hear. All of our
        products are genuine and shipped directly from product manufacturers
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam risus
        tellus, euismod vel rutrum vitae, scelerisque vitae leo. Aenean sed orci
        mollis magna ornare mollis. Vestibulum eu suscipit ex. Ut vel mi a orci
        posuere sodales. Duis a est eget leo varius tristique sed ac est. Duis
        finibus porta molestie. Quisque semper quam ut elit dapibus dapibus. Sed
        ut suscipit magna. Quisque in dolor ultrices, feugiat enim vel, molestie
        est. Phasellus dapibus ultrices egestas.{" "}
      </p>
      <p>
        Nulla facilisi. Aenean vitae sollicitudin nulla, quis posuere nunc.
        Class aptent taciti sociosqu ad litora torquent per conubia nostra, per
        inceptos himenaeos. Pellentesque nulla nisi, accumsan sed lacinia id,
        lobortis a lacus. Vestibulum sem tellus, sodales ac metus id, varius
        efficitur ex. Phasellus pulvinar nisi eu erat finibus tempor.
      </p>
    </div>
  );
};

export default About;
